/* @flow */
import Reflux from "reflux";

const ListAction = Reflux.createActions(["getLists", "create"]);

export default ListAction;
